import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { clientSettingsSelector } from '../../store/slices/clientsettings';

const darkThemeIconColor = '#fff';
const lightThemeIconColor = 'rgba(0, 0, 0, 0.65)';

const FuelDuplicateIcon = ({ className, onActionButtonClick, title }) => {
  const { themeName } = useSelector(clientSettingsSelector);

  useEffect(() => {
    // console.log('themeName changed', themeName);
  }, [themeName]);
  return (
    <span
      title={title}
      className={className}
      onClick={(e) => {
        onActionButtonClick(e);
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path
          className="icon"
          fill={themeName === 'light-theme-viewnexa' ? darkThemeIconColor : lightThemeIconColor}
          d="M8,7 L8,5.50100238 C8,4.1202905 9.11928813,3.00100238 10.5,3.00100238 L16.4720225,3.00100238 C16.6047688,2.99258291 16.7429463,3.03684187 16.8535534,3.14744899 L19.8535534,6.14744899 C19.9641605,6.25805611 20.0084195,6.39623363 20,6.52897986 L20,14.5010024 C20,15.8817143 18.8807119,17.0010024 17.5,17.0010024 L16,17.0010024 L16,18.5 C16,19.8807119 14.8807119,21 13.5,21 L6.5,21 C5.11928813,21 4,19.8807119 4,18.5 L4,9.5 C4,8.11928813 5.11928813,7 6.5,7 L8,7 Z M8,8 L6.5,8 C5.67157288,8 5,8.67157288 5,9.5 L5,18.5 C5,19.3284271 5.67157288,20 6.5,20 L13.5,20 C14.3284271,20 15,19.3284271 15,18.5 L15,17.0010024 L12.5,17.0010024 C12.2238576,17.0010024 12,16.7771448 12,16.5010024 C12,16.22486 12.2238576,16.0010024 12.5,16.0010024 L17.5,16.0010024 C18.3284271,16.0010024 19,15.3294295 19,14.5010024 L19,7.00100238 L16.5,7.00100238 C16.2238576,7.00100238 16,6.77714475 16,6.50100238 L16,4.00100238 L10.5,4.00100238 C9.67157288,4.00100238 9,4.67257525 9,5.50100238 L9,10.5000237 C9,10.7761595 8.77614767,11.0000118 8.50001183,11.0000118 L8.5,11.0000118 C8.22385571,11.0000053 8,10.7761443 8,10.5 L8,8 Z M17,6.00100238 L18.2928932,6.00100238 L17,4.70810916 L17,6.00100238 Z M13.2928932,10 L11.5,10 C11.2238576,10 11,9.77614237 11,9.5 C11,9.22385763 11.2238576,9 11.5,9 L14.5,9 C14.7761424,9 15,9.22385763 15,9.5 L15,12.5 C15,12.7761424 14.7761424,13 14.5,13 C14.2238576,13 14,12.7761424 14,12.5 L14,10.7071068 L8.85355339,15.8535534 C8.65829124,16.0488155 8.34170876,16.0488155 8.14644661,15.8535534 C7.95118446,15.6582912 7.95118446,15.3417088 8.14644661,15.1464466 L13.2928932,10 L13.2928932,10 Z"
        />
      </svg>
    </span>
  );
};

export default FuelDuplicateIcon;
